import indexedColor from '../../../theming/docusign-themes/olive/tokens/indexedColor'
import type { Tokens } from '../../../theming/types'
import type { AvatarProps } from '..'

export default (config: {
  props: Pick<AvatarProps, 'colorIndex' | 'shape'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      wrap: {
        '& > a:hover': {
          boxShadow: '0 0 0 4px transparent',
        },

        '& > a:active': {
          boxShadow: '0 0 0 4px transparent !important',
        },
      },

      avatar: {
        backgroundColor:
          props.colorIndex !== undefined
            ? indexedColor(props.colorIndex).solid
            : tokens.avatarBgColor1,
        color: '#1e1e1e',
        fontFamily: tokens.fontBodyM.fontFamily,
        fontWeight: 600,
        lineHeight: 1.5,

        '&:hover': {
          color: '#1e1e1e',
        },
      },
    },

    placeholder: {
      avatar: {
        color: tokens.fontColorInverse,

        '& > svg': {
          borderRadius: '50%',
          fill: tokens.iconColorInverse,
          height: '100%',
          overflow: 'hidden',
          width: '100%',
        },
      },
    },

    sizeXxlarge: {
      avatar: {
        fontSize: '22px',
        height: '96px',
        width: '96px',
        borderRadius: props.shape === 'square' ? '4px' : '50%',
      },
    },

    sizeXlarge: {
      avatar: {
        fontSize: '22px',
        height: '72px',
        width: '72px',
        borderRadius: props.shape === 'square' ? '4px' : '50%',
      },
    },

    sizeLarge: {
      avatar: {
        fontSize: '15px',
        height: '48px',
        width: '48px',
        borderRadius: props.shape === 'square' ? '4px' : '50%',
      },
    },

    sizeMedium: {
      avatar: {
        fontSize: '15px',
        height: '36px',
        width: '36px',
        borderRadius: props.shape === 'square' ? '4px' : '50%',
      },
    },

    sizeSmall: {
      avatar: {
        fontSize: '13px',
        height: '28px',
        width: '28px',
        borderRadius: props.shape === 'square' ? '2px' : '50%',
      },
    },

    sizeXsmall: {
      avatar: {
        fontSize: '10px',
        height: '20px',
        width: '20px',
        borderRadius: props.shape === 'square' ? '2px' : '50%',
      },
    },
  } as const
}
